import { HTMLAttributes } from 'react'

import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'
import { SalesPoint, SalesPointCategory } from '@/types/sales-network'

export type StoreFiltersProps = HTMLAttributes<HTMLDivElement> & {
  categories: SalesPointCategory[]
  selectedCategories: number[]
  stores: SalesPoint[]
  onCategorySelect: (_categoryId: number | null) => void
}

const StoreFilters = ({
  categories,
  selectedCategories,
  // stores,
  onCategorySelect,
  className,
  ..._props
}: StoreFiltersProps) => {
  const { strings } = useStore()

  return (
    <div className={className}>
      <div
        role="group"
        aria-label={strings?.labels?.store_filters || 'Filtri punti vendita'}
        className="flex flex-row flex-wrap gap-spacing-2xs"
      >
        {categories.map((category) => (
          <button
            key={category.term_id}
            aria-pressed={selectedCategories.includes(category.term_id)}
            className={cn(
              'flex h-[3.2rem] items-center border border-[rgba(255,255,255,0.3)] px-spacing-2xs transition-all duration-300',
              selectedCategories.includes(category.term_id) && 'bg-[#F2F2F2]'
            )}
            onClick={() => onCategorySelect(category.term_id)}
          >
            <Typography
              variant="regular"
              className={cn(
                'condensed text-text-secondary-dark transition-all duration-300',
                selectedCategories.includes(category.term_id) &&
                  'text-text-button-primary-dark'
              )}
            >
              {category.name}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  )
}

export default StoreFilters
